import { gsap } from 'gsap';
import { str2json, getClosest } from '@utils';

if (!customElements.get('footer-nav')) {
  customElements.define(
    'footer-nav',
    class FooterNav extends HTMLElement {
      constructor() {
        super();
        this.navItems = this.querySelectorAll('.Nav__item.level-1.has-submenu')
        this.breakpoint = this.dataset.breakpoint;
        this.bindEvents()
      }

      connectedCallback() {
        if (this.breakpoint) {
          this.checkbreakpoint()
        }
      }

      static get observedAttributes() {
        return ['data-style'];
      }

      get isAccordion() {
        return this.getAttribute('data-style') == 'accordion' ? true : false;
      }

      attributeChangedCallback(name, oldValue, newValue) {

        if (name == 'data-style' && newValue == 'accordion') {
          this.navItems.forEach((item, idx) => {
            item.setAttribute('aria-expandable', false)
            const target = item.querySelector('.Nav__link.level-1');
            target.addEventListener('click', this.handleClick, true)
          })
        } else if (name == 'data-style' && newValue == 'grid') {
          this.navItems.forEach((item, idx) => {
            item.removeAttribute('aria-expandable')
            const target = item.querySelector('.Nav__link.level-1');
            const submenu = item.querySelector('.Nav__submenu.level-1');
            target.removeEventListener('click', this.handleClick, true)
            gsap.set(submenu, { clearProps: 'height,opacity' })
          })
        }
      }

      bindEvents() {
        if (this.breakpoint) {
          window.addEventListener('resize', () => this.checkbreakpoint())
        }
      }

      handleClick(e) {
        e.preventDefault()
        const item = getClosest(e.target, '.Nav__item')
        if (item.getAttribute('aria-expanded') == "true") {
          item.setAttribute('aria-expanded', false)
          gsap.to(item.querySelector('.Nav__submenu'), { height: 0, opacity: 0 })
        } else {
          item.setAttribute('aria-expanded', true);
          gsap.to(item.querySelector('.Nav__submenu'), { height: 'auto', opacity: 1 })
        }
      }

      checkbreakpoint() {
        if (this.getAttribute('data-breakpoint')) {
          if (window.matchMedia(`(max-width: ${this.breakpoint})`).matches && !this.isAccordion) {
            this.setAttribute('data-style', 'accordion');
          }
          if (!window.matchMedia(`(max-width: ${this.breakpoint})`).matches && this.isAccordion) {
            this.setAttribute('data-style', 'grid');
          }
        }
      }
    }
  );
}

